<template>
  <div v-click-outside="hide">
    <nav
      aria-label="TCNA Site Menu"
      class="site-menu"
      :class="{'-active' : isActive, '-short' : shortMode }"
    >
      <div class="site-menu__container | container--lg gutter--xs">
        <!-- Group -->
        <div class="site-menu__group -primary">
          <!-- Logo -->
          <a aria-label="home" href="/" class="site-menu__logo | timing-2 property-all duration-3">
            <span class="icon brand-logo">
              <svg id="toyota-brand" width="210" height="70" viewBox="0 0 210 70" fill="none">
                <g clip-path="url(#clip0)">
                  <path d="M0 0V20.25H29.02V69.3H49.27V20.25H39.15V0H0Z" fill="#D62328"/>
                  <path d="M79.71 0H69.59V10.12H79.71V0Z" fill="#A1C8DB"/>
                  <path d="M49.27 0H39.15V10.12H49.27V0Z" fill="#EC008C"/>
                  <path d="M59.39 10.12H49.27V20.24H59.39V10.12Z" fill="#D62328"/>
                  <path d="M44.2 15.18H39.14V20.24H44.2V15.18Z" fill="#C40380"/>
                  <path d="M69.58 10.12H64.52V15.18H69.58V10.12Z" fill="#AEAF2F"/>
                  <path d="M95.23 18.95H101.29V34.4H105.55V18.95H111.58V15.28H95.23V18.95ZM189.45 15.28H173.1V18.95H179.16V34.4H183.42V18.95H189.45V15.28ZM147.53 15.28L142.58 23.02L137.63 15.28H132.79L140.45 27.27V34.4H144.71V27.27L152.37 15.28H147.53ZM122.57 14.62C116.99 14.62 112.47 19.14 112.47 24.72C112.47 30.3 116.99 34.82 122.57 34.82C128.15 34.82 132.67 30.3 132.67 24.72C132.67 19.15 128.15 14.62 122.57 14.62ZM122.57 31.08C119.42 31.08 116.87 28.24 116.87 24.73C116.87 21.22 119.42 18.38 122.57 18.38C125.72 18.38 128.27 21.23 128.27 24.73C128.27 28.23 125.72 31.08 122.57 31.08ZM162.43 14.62C156.85 14.62 152.33 19.14 152.33 24.72C152.33 30.3 156.85 34.82 162.43 34.82C168.01 34.82 172.53 30.3 172.53 24.72C172.53 19.15 168 14.62 162.43 14.62ZM162.43 31.08C159.28 31.08 156.73 28.24 156.73 24.73C156.73 21.22 159.28 18.38 162.43 18.38C165.58 18.38 168.13 21.23 168.13 24.73C168.13 28.23 165.57 31.08 162.43 31.08ZM201.82 15.28H196.23L188.43 34.4H193.27L195.05 29.73H203.01L204.79 34.4H209.63L201.82 15.28ZM196.34 26.34L199.03 19.29L201.72 26.34H196.34Z" fill="#D62328"/>
                  <path d="M167.62 58.93C164.05 58.93 161.14 55.96 161.14 52.3C161.14 48.65 164.05 45.67 167.62 45.67C169.53 45.67 171.33 46.53 172.56 48.02L171.52 48.88C170.54 47.7 169.12 47.02 167.62 47.02C164.79 47.02 162.49 49.39 162.49 52.29C162.49 55.19 164.79 57.56 167.62 57.56C169.12 57.56 170.54 56.88 171.52 55.7L172.56 56.56C171.33 58.08 169.52 58.93 167.62 58.93ZM101.04 58.93C97.47 58.93 94.56 55.96 94.56 52.3C94.56 48.65 97.47 45.67 101.04 45.67C102.95 45.67 104.75 46.53 105.98 48.02L104.94 48.88C103.96 47.7 102.54 47.02 101.04 47.02C98.21 47.02 95.91 49.39 95.91 52.29C95.91 55.19 98.21 57.56 101.04 57.56C102.54 57.56 103.97 56.88 104.94 55.7L105.98 56.56C104.74 58.08 102.94 58.93 101.04 58.93ZM202.65 58.93C199.08 58.93 196.17 55.96 196.17 52.3C196.17 48.65 199.08 45.67 202.65 45.67C204.58 45.67 206.21 46.51 207.41 48.09V42.52H208.76V58.25H207.41V56.51C206.21 58.09 204.58 58.93 202.65 58.93ZM202.65 47.03C199.82 47.03 197.52 49.4 197.52 52.3C197.52 55.2 199.82 57.57 202.65 57.57C205.35 57.57 206.73 55.49 207.41 53.69V50.91C206.73 49.11 205.35 47.03 202.65 47.03ZM188.89 58.93C185.49 58.93 182.72 55.96 182.72 52.3C182.72 48.65 185.49 45.67 188.89 45.67C192.47 45.67 194.69 48.81 194.69 51.71V52.39H184.07C184.12 55.25 186.26 57.57 188.89 57.57C190.3 57.57 191.63 56.9 192.55 55.73L193.61 56.56C192.43 58.07 190.71 58.93 188.89 58.93ZM184.21 51.05H193.29C192.99 49.01 191.37 47.03 188.89 47.03C186.63 47.03 184.72 48.75 184.21 51.05ZM179.18 58.93C177.08 58.93 175.36 57.18 175.36 55.04V47.3H173.69V45.95H175.36V42.53H176.71V45.95H180.98V47.3H176.71V55.04C176.71 56.44 177.81 57.58 179.17 57.58C179.89 57.58 180.57 57.26 181.04 56.69L182.08 57.55C181.36 58.43 180.3 58.93 179.18 58.93ZM154.02 58.93C150.61 58.93 147.84 55.96 147.84 52.3C147.84 48.65 150.61 45.67 154.02 45.67C157.6 45.67 159.82 48.81 159.82 51.71V52.39H149.2C149.25 55.25 151.39 57.57 154.02 57.57C155.42 57.57 156.76 56.9 157.68 55.73L158.74 56.57C157.57 58.07 155.85 58.93 154.02 58.93ZM149.34 51.05H158.42C158.12 49.01 156.5 47.03 154.02 47.03C151.76 47.03 149.86 48.75 149.34 51.05ZM113.05 58.93C109.48 58.93 106.57 55.96 106.57 52.3C106.57 48.65 109.48 45.67 113.05 45.67C116.62 45.67 119.53 48.64 119.53 52.3C119.53 55.96 116.62 58.93 113.05 58.93ZM113.05 47.03C110.22 47.03 107.92 49.4 107.92 52.3C107.92 55.2 110.22 57.57 113.05 57.57C115.88 57.57 118.18 55.2 118.18 52.3C118.18 49.4 115.87 47.03 113.05 47.03ZM146.52 58.25H145.17V52.3C145.17 49.39 143.13 47.03 140.62 47.03C138.11 47.03 136.07 49.4 136.07 52.3V58.25H134.72V52.3C134.72 48.65 137.37 45.67 140.62 45.67C143.87 45.67 146.52 48.64 146.52 52.3V58.25ZM132.9 58.25H131.55V52.3C131.55 49.39 129.51 47.03 127 47.03C124.49 47.03 122.45 49.4 122.45 52.3V58.25H121.1V52.3C121.1 48.65 123.75 45.67 127 45.67C130.25 45.67 132.9 48.64 132.9 52.3V58.25Z" fill="black"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                  <rect width="209.62" height="69.3" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="icon | brand-mark">
              <svg id="toyota-mark" width="78px" height="68px" viewBox="0 0 78 68">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="toyota-mark_fill" fill-rule="nonzero">
                    <polygon id="Path" fill="#D62328" points="0 0 0 19.6714286 28.1908571 19.6714286 28.1908571 67.32 47.8622857 67.32 47.8622857 19.6714286 38.0314286 19.6714286 38.0314286 0"></polygon>
                    <polygon id="Path" fill="#A1C8DB" points="77.4325714 0 67.6017143 0 67.6017143 9.83085714 77.4325714 9.83085714"></polygon>
                    <polygon id="Path" fill="#EC008C" points="47.8622857 0 38.0314286 0 38.0314286 9.83085714 47.8622857 9.83085714"></polygon>
                    <polygon id="Path" fill="#D62328" points="57.6931429 9.83085714 47.8622857 9.83085714 47.8622857 19.6617143 57.6931429 19.6617143"></polygon>
                    <polygon id="Path" fill="#C40380" points="42.9371429 14.7462857 38.0217143 14.7462857 38.0217143 19.6617143 42.9371429 19.6617143"></polygon>
                    <polygon id="Path" fill="#AEAF2F" points="67.592 9.83085714 62.6765714 9.83085714 62.6765714 14.7462857 67.592 14.7462857"></polygon>
                  </g>
                </g>
              </svg>
            </span>
          </a>

          <!-- Toggle -->
          <div class="site-menu__toggle">
            <div @click="toggleMenu" class="btn--toggle -arrow" :class="{'-active' : isActive}">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        <!-- Group -->
        <nav class="site-menu__group -secondary">
          <ul aria-label="Main Menu" class="site-menu__bar -lg | timing-2 property-all duration-3">

            <li v-for="item in items" class="site-menu__bar__li" :class="item.active">
              <a class="site-menu__link link" :href="item.link" :aria="item.aria">{{ item.title }}</a>
            </li>

            <li class="site-menu__bar__li" @click="showModal()">
              <span class="site-menu__link link">Contact</span>
            </li>
          </ul>
        </nav>
      </div>

      <transition name="fade-right" v-on:enter="enter" v-on:leave="leave">
        <div v-if="isActive" class="site-menu__offscreen">
          <div class="site-menu__offscreen-inner">
            <!-- Group -->
            <div class="site-menu__offscreen-group">
              <nav aria-label="TCNA Main Menu" class="site-menu__offscreen-group -primary">
                <ul class="site-menu__bar -sm">
                  <li v-for="item in items" class="site-menu__bar__li">
                    <a class="site-menu__link link" :class="item.active" :href="item.link">{{ item.title }}</a>
                  </li>
                  <li class="site-menu__bar__li" @click="showModal()">
                    <span class="link">Contact</span>
                  </li>

                </ul>
              </nav>
            </div>
          </div>
        </div>
      </transition>
    </nav>
  </div>
</template>

<script type="text/babel">
  import clickOutside from "../directives/ClickOutslide";
  import contactModal from "./ContactModal";

  import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
  } from "body-scroll-lock";

  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      primarycta: {
        required: true
      },
      email: {
        required: true
      },
      address: {
        required: true
      },
      sociallinks: {
        required: true
      }
    },

    data() {
      return {
        isActive: false,
        menuH: "100vh",
        siteFooter: null,
        shortMode: false,
        goingDown: false
      };
    },

    mounted() {
      // - Hande Load
      window.addEventListener("load", this.onLoad);

      // - Hande Scroll
      window.addEventListener("scroll", this.onScroll);

      // - Handle Keypress Events
      this.handleKeys();
    },

    methods: {
      showModal(){
        this.$root.$emit("openModal", true);
      },

      onScroll() {
        // At Top
        if (document.body.getBoundingClientRect().top < -200) {
          this.shortMode = true;
          this.goingDown = true;
        } else {
          this.shortMode = false;
          this.goingDown = false;
        }

        // This will swap based on UP/DOWN:
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          this.goingDown = false;
        } else {
          this.goingDown = true;
        }
        this.scrollPos = document.body.getBoundingClientRect().top;
      },

      onLoad() {
        if (document.body.getBoundingClientRect().top < -100)
          this.shortMode = true;
      },

      getElements() {
        this.siteFooter = document.querySelector(".site-footer");
      },

      getElementInfo() {
        // Get height values

        const docH = document.body.clientHeight;
        const footerH = this.siteFooter.offsetHeight;
        console.log(this.siteFooter);

        // Set header height
        this.menuH = docH - footerH + "px";
      },

      handleResize() {
        window.onresize = this.getElementInfo;
      },

      handleKeys() {
        // Handle Escape
        document.body.addEventListener("keyup", e => {
          if (e.keyCode === 27) {
            this.isActive = false;
          }
        });
      },

      hide() {
        this.isActive = false;
      },

      enter() {
        const scrollable = this.$el.querySelector(".site-menu__offscreen");
        disableBodyScroll(scrollable);
      },

      leave() {
        const scrollable = this.$el.querySelector(".site-menu__offscreen");
        enableBodyScroll(scrollable);
      },

      toggleMenu() {
        // Handle Toggle
        if (!this.isActive) {
          // Open
          this.isActive = true;
        } else {
          // Close
          this.isActive = false;
        }
      }
    },

    directives: {
      "click-outside": clickOutside
    },

    components: {
      contactModal
    }
  };
</script>

<style>
  .fade-right-enter-active,
  .fade-right-leave-active {
    transition: 0.3s cubic-bezier(0.71, -0.01, 0.25, 0.65) transform;
  }
  .fade-right-enter,
  .fade-right-leave-to {
    transform: translate(-100%, 0);
  }
</style>
